
import 'jquery';
import 'jquery-ui-dist/jquery-ui';
// import 'jquery-ui-dist/jquery-ui.css';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { provideNgIdle } from '@ng-idle/core';
import { BrowserModule } from '@angular/platform-browser';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations, BrowserAnimationsModule  } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { NgxCaptchaModule } from 'ngx-captcha';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { GoogleChartsModule, provideGoogleCharts, ScriptLoaderService } from 'angular-google-charts';
import { MsalService, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { DASHBOARD_ROUTES } from './app/pages/dashboard/dashboard.routes';
import { provideNgxMask } from 'ngx-mask';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideNativeDatetimeAdapter } from '@ng-matero/extensions/core';
import { jwttokeninterceptor } from './app/services/jwttokeninterceptor';
import { LoaderInterceptor } from './app/services/loader-interceptor/loader-interceptor.service';
import { LoaderService } from './app/services/loader-service/loader.service';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import{registerLicense} from '@syncfusion/ej2-base';
registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCe0x3Qnxbf1x2ZF1MZV1bRXRPMyBoS35RcEVnWHheeHFQR2FfV0JxVEFe');

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: 'd29ab21d-4229-446a-a402-5dc356978527',
    redirectUri: 'http://localhost:4422' // must match Azure
  }
});

async function main() {
  await msalInstance.initialize();

  await bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      {
        provide: MSAL_INSTANCE,
        useValue: msalInstance
      },
      {
        provide: MsalService,
        useClass: MsalService
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useValue: {
          interactionType: InteractionType.Popup
        }
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useValue: {
          interactionType: InteractionType.Popup,
          protectedResourceMap: new Map()
        }
      },
      provideHttpClient(withInterceptors([jwttokeninterceptor]),
       withInterceptorsFromDi()),
      {
        provide: HTTP_INTERCEPTORS,
        useClass: LoaderInterceptor,
        multi: true
      },
      provideRouter(appRoutes),
      // Modules
      provideNgIdle(),
        importProvidersFrom(BrowserModule, BrowserAnimationsModule, ModalModule.forRoot(),
          GoogleChartsModule.forRoot({ 'version': '46.2' }),
          ToastrModule.forRoot({ positionClass: 'toast-top-center', preventDuplicates: true }), NgxCaptchaModule,
          NgxCaptchaModule,
          NgxLoadingModule.forRoot({})),
        LoaderService, ScriptLoaderService,
        provideAnimations(),
        provideAnimationsAsync(),
          DatePipe,
        provideGoogleCharts(),
        provideRouter(DASHBOARD_ROUTES),
        provideNgxMask(),
        provideMomentDateAdapter(),
        provideNativeDatetimeAdapter(),
        providePrimeNG(
          {
            theme: {
              preset: Lara,
              options: {
                darkModeSelector: 'none'
              }
            },
            zIndex: {
              modal: 1100,
              overlay: 99999,
              menu: 99999,
              tooltip: 99999
            }
          }
        )
    ]
  });
}
main();